export const mapLinkAction = (openingOrClosing: string) =>
  openingOrClosing === 'opening' ? 'expand' : 'collapse';
